import React from "react";
import NavBar from '../Components/NavBar/NavBar'
import Form from '../Components/CreateEventForm/CreateEventForm'


function CreateEvent() {
  return (
    <div>
       <NavBar/>
      <Form/>
       
    </div>
  );
}

export default CreateEvent;
